<p class="m-0 muted-less">
    <ng-content></ng-content>
</p>